import { Component, Input } from '@angular/core';
import Employee from 'src/app/model/product/employee';

@Component({
  selector: 'employee-with-badge',
  templateUrl: './employee-with-badge.component.html',
  styleUrls: ['./employee-with-badge.component.scss']
})
export class EmployeeWithBadgeComponent {
  @Input()
  employee: Employee;
  @Input()
  svgIcon: string;
  @Input()
  transformClass: string;
  @Input()
  borderColor: string;
  @Input()
  locationVerification: boolean = false;
}
